import { type FC } from 'react';

import { PikLogo } from './PikLogo';
import { trackPikLogoClick } from './internal/tracking/trackPikLogoClick';

export const PikLogoContainer: FC = () => <PikLogo onLogoAnalyticsClick={trackPikLogoClick} />;
